import { useState, useEffect } from "react";

const SECTIONS = [
  { id: "about",       label: "About" },
  { id: "services",    label: "Services" },
  { id: "products",    label: "Products" },
  { id: "brands",      label: "Brands" },
  { id: "distributor", label: "Distributors" },
  { id: "portfolio",   label: "Gallery" },
  { id: "contact",     label: "Contact" },
];

export const Navigation = () => {
  const [active,   setActive]   = useState("");
  const [scrolled, setScrolled] = useState(false);
  const [open,     setOpen]     = useState(false);

  useEffect(() => {
    const onScroll = () => {
      setScrolled(window.scrollY > 60);
      const offset = window.scrollY + 90;
      let cur = "";
      SECTIONS.forEach(({ id }) => {
        const el = document.getElementById(id);
        if (el && el.offsetTop <= offset) cur = id;
      });
      setActive(cur);
    };
    window.addEventListener("scroll", onScroll, { passive: true });
    onScroll();
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const closeMenu = () => setOpen(false);

  return (
    <nav
      id="menu"
      className={`navbar navbar-default navbar-fixed-top${scrolled ? " scrolled" : ""}`}
      role="navigation"
      aria-label="Main navigation"
    >
      <div className="container">
        {/* Brand + Toggle — always on same line */}
        <div className="navbar-header">
          <a className="navbar-brand page-scroll" href="#page-top" onClick={closeMenu}>
            <img
              src="https://res.cloudinary.com/dbgzzcwvr/image/upload/v1756632676/icon_xqzodb.png"
              alt="Netra Bharat Industries"
              className="navbar-logo"
              width="34" height="34"
            />
            <span>Netra Bharat Industries</span>
          </a>
          <button
            type="button"
            className="navbar-toggle"
            onClick={() => setOpen(!open)}
            aria-expanded={open}
            aria-controls="nb-nav"
            aria-label={open ? "Close menu" : "Open menu"}
          >
            <span className="icon-bar"></span>
            <span className="icon-bar"></span>
            <span className="icon-bar"></span>
          </button>
        </div>

        {/* Nav links */}
        <div
          className={`navbar-collapse${open ? " in" : " collapse"}`}
          id="nb-nav"
          aria-hidden={!open}
        >
          <ul className="nav navbar-nav navbar-right">
            {SECTIONS.map(({ id, label }) => (
              <li key={id} className={active === id ? "nb-active" : ""}>
                <a
                  href={`#${id}`}
                  className="page-scroll"
                  onClick={closeMenu}
                >
                  {label}
                </a>
              </li>
            ))}
          </ul>
        </div>
      </div>
    </nav>
  );
};
